import script from "./RecorderDuration.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecorderDuration.vue?vue&type=script&setup=true&lang=ts"

import "./RecorderDuration.vue?vue&type=style&index=0&id=a0ecad26&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0ecad26"]])

export default __exports__